import { ISelectType } from "@4uhub/lib4uhub";

export const REAGENDAMENTO_AUTOMATION_CODES = ["31", "32"];

export const TASY_NPS_SATISFACTION_SURVEY_AUTOMATION_CODE = "3";

export const isReagendamentoAutomationCode = (
  code?: string | null,
): boolean => REAGENDAMENTO_AUTOMATION_CODES.includes(String(code));

export const getReagendamentoFixedActionType = (
  actionTypes?: ISelectType[] | null,
): ISelectType | null => {
  if (!actionTypes?.length) return null;

  const code12ActionType = actionTypes.find(
    (actionType) => String(actionType.code) === "12",
  );

  return code12ActionType ?? null;
};

export const getNormalizedWhatsappActionTypes = (
  code?: string | null,
  actionTypes?: ISelectType[] | null,
): ISelectType[] => {
  if (!actionTypes?.length) return [];

  if (isReagendamentoAutomationCode(code)) {
    const fixedActionType = getReagendamentoFixedActionType(actionTypes);
    return fixedActionType ? [fixedActionType] : [];
  }

  return actionTypes;
};
